module.exports = __webpack_public_path__ + "static/media/logo-text.60248c2f.png";